@if (car) {
  <div class="car-info-card car-info-card--type-{{ type }}">
    <app-image class="car-info-card__image" [src]="car.gallery?.[0]?.data?.thumb" [alt]="'car'" [priority]="true" [width]="327" [height]="240"></app-image>
    <div class="car-info-card__content">
      <div class="car-info-card__top">
        <h5 class="car-info-card__title notranslate">{{ car.make.title + ' ' + car.model.title + (car.engine?.title ? ', ' + car.engine?.title : '') + (car.model.lineTitle ? ', ' + car.model.lineTitle : '') }}</h5>
        {{ car.productionYear }}
        {{ car.mileage ? ('· ' + (car.mileage | thousands) + ' ' + car.mileageUnit | lowercase) : '' }}
        {{ car.engine?.is4x4 ? '· 4x4' : '' }}
        {{ car.isFirstOwner ? '·' + ('globals.firstOwner' | translate) : '' }}
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </div>
      @if ((car.price.cash || car.price.cashWithoutVAT) && !hidePrice) {
        <div class="car-card-info__prices">
          @if (car.price.cash) {
            <div class="car-card-info__price">
              {{ car.price.cash | price }}
            </div>
          }
          @if (car.price.cashWithoutVAT && car.price.cashWithoutVAT !== car.price.cash && car.price.isVATDeduct) {
            <div>{{ car.price.cashWithoutVAT | price }} {{ 'globals.withoutVAT' | translate }}</div>
          }
        </div>
      }
    </div>
  </div>
} @else {
  <div class="car-info-card car-info-card--type-{{ type }}">
    <app-image class="car-info-card__image" [src]="image" [alt]="title || ''" [placeholder]="false" [width]="260" [height]="190"></app-image>
    <div class="car-info-card__content">
      <div class="car-info-card__top">
        <h5 class="car-info-card__title">{{ title }}</h5>
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </div>
      @if ((price || priceWithoutVat) && !hidePrice) {
        <div class="car-card-info__prices">
          @if (price) {
            <div class="car-card-info__price">
              {{ price | price }}
            </div>
          }
          @if (priceWithoutVat) {
            <div>{{ priceWithoutVat | price }} {{ 'globals.withoutVAT' | translate }}</div>
          }
        </div>
      }
    </div>
  </div>
}

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
